'use strict';
import angular from 'angular';
import pinterestFrequencyHtmlUrl from './views/pinterestads.frequency.html';

let app = angular.module('app.pinterestAdsFrequencyComponent', []);

app.component('pinterestAdsFrequency', {
    bindings: {
        showActions: '=',
        sets: '=',
        readOnly: '<'
    },
    templateUrl: pinterestFrequencyHtmlUrl,

    // The controller that handles our component logic
    controller: function() {
        let self = this;
        self.unitTypes = ['Optional'];

        self.initComponent = function() {
            if (self.sets && self.sets.length > 0) {
                if (typeof self.sets == 'string') {
                    self.sets = JSON.parse(self.sets);
                }
                if (self.showActions) {
                    self.showFrequencyView = false;
                    self.enableEditView = true;
                } else {
                    self.showFrequencyView = true;
                    self.enableEditView = false;
                }

            } else {
                self.sets = [
                    {
                        impressions: null,
                        durationUnits: null,
                        unitType: ''
                    }
                ];
                self.showFrequencyView = false;
            }
        };

        self.initComponent();
    }
});
